export enum VehicleStatus{
    HOD_APPROVAL_PENDING='HOD APPROVAL PENDING',
    ADMIN_APPROVAL_PENDING='ADMIN APPROVAL PENDING',
    WAITING_ON_VENDOR='WAITING ON VENDOR',
    VEHICLE_ASSIGNED='VEHICLE ASSIGNED',
    REJECTED='REJECTED',
    TRIP_STARTED='TRIP STARTED',
    TRIP_COMPLETED='TRIP COMPLETED'
}